import { Accordion } from '@iwoca/orion';
import { t } from '@lingui/core/macro';

import { useIsInDEOpenBankingCopyTest } from '../../../../hooks/useIsInDEOpenBankingCopyTest';
import { useLocale } from '../../../../hooks/useLocale';
import { TOfferDataRequirement } from '../../../../types';
import ManualUploadDE from '../../TradingHistoryDE/RequirementTypes/BankStatementsDE/ManualUploadDE';
import ManualUploadUK from '../../TradingHistoryUK/RequirementTypes/BankStatements/ManualUpload';

type TProps = {
  title: string;
  status?: TOfferDataRequirement['actions'][number]['status'];
  isSubmitted: boolean;
};

const ManualUploadAccordion = ({ title, status, isSubmitted }: TProps) => {
  const { isDE } = useLocale();
  const { isIncludedInOBCopyTest } = useIsInDEOpenBankingCopyTest();

  return (
    <Accordion
      title={
        isIncludedInOBCopyTest
          ? t`I am having trouble sharing my bank statements...`
          : t`My bank is not available to link`
      }
      small
      variant={isIncludedInOBCopyTest ? 'primary' : 'secondary'}
      frame={!isIncludedInOBCopyTest}
    >
      {isDE ? (
        <ManualUploadDE
          title={title}
          status={status}
          isSubmitted={isSubmitted}
        />
      ) : (
        <ManualUploadUK
          title={title}
          status={status}
          isSubmitted={isSubmitted}
        />
      )}
    </Accordion>
  );
};

export default ManualUploadAccordion;
